import * as React from 'react'

import Svg, {
  ClipPath,
  Defs,
  Ellipse,
  G,
  Path,
  RadialGradient,
  Rect,
  Stop,
} from 'react-native-svg'

const ReferAndEarnSVG = ({ ...props }) => {
  return (
    <Svg
      width={49}
      height={48}
      viewBox="0 0 49 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <G clipPath="url(#clip0_103_2627)">
        <Rect x={0.333252} width={48} height={48} rx={8} fill="#F2F7FF" />
        <Ellipse cx={24.9999} cy={33} rx={19} ry={19.5} fill="#ECEFF5" />
        <Path
          d="M32.432 33.214c0 4.28-3.37 7.75-7.53 7.75-2.191 0-4.164-.964-5.54-2.503a7.763 7.763 0 01-.953-1.324 7.891 7.891 0 01-1.035-3.923c0-4.281 3.37-7.752 7.529-7.752 1.39 0 2.693.389 3.81 1.065.463.28.894.61 1.287.982a7.832 7.832 0 012.432 5.704z"
          fill="#F0CD00"
        />
        <Path
          d="M32.432 33.214c0 4.184-3.22 7.593-7.249 7.745-4.028-.152-7.248-3.561-7.248-7.745 0-4.185 3.22-7.595 7.248-7.746 4.029.151 7.249 3.561 7.249 7.746z"
          fill="#FFDE50"
        />
        <Path
          d="M30.752 33.213c0 3.327-2.62 6.023-5.85 6.023a5.7 5.7 0 01-3.069-.894 5.911 5.911 0 01-1.714-1.66 6.092 6.092 0 01-1.067-3.395v-.074c0-3.327 2.62-6.023 5.85-6.023h.072a5.685 5.685 0 013.298 1.098 5.995 5.995 0 011.612 1.765c.55.918.869 2 .869 3.159v.001z"
          fill="#FAA300"
        />
        <Path
          d="M29.04 28.954l-8.273 8.517a6.017 6.017 0 01-1.307-2.048 6.148 6.148 0 01-.406-2.137v-.074c0-3.327 2.62-6.023 5.85-6.023h.072a5.683 5.683 0 013.298 1.098c.274.2.53.422.767.665l-.002.002z"
          fill="#FFBD00"
        />
        <Path
          d="M30.752 33.214c0 3.326-2.62 6.023-5.85 6.023-.11 0-.22-.004-.33-.01 3.076-.176 5.519-2.802 5.519-6.013 0-3.212-2.443-5.838-5.52-6.014.11-.006.22-.01.33-.01 3.232 0 5.851 2.697 5.851 6.024z"
          fill="#F68E00"
        />
        <Path
          d="M27.228 31.369h-1.025a2.588 2.588 0 00-.266-.663h1.29c.34 0 .616-.283.616-.632a.624.624 0 00-.615-.633h-5.806a.624.624 0 00-.615.633c0 .349.275.632.615.632h2.372c.47 0 .88.268 1.096.663h-3.468a.624.624 0 00-.615.632c0 .35.275.633.615.633h3.468a1.254 1.254 0 01-1.096.663h-2.372a.614.614 0 00-.564.381.647.647 0 00.116.685l3.343 3.653a.603.603 0 00.868.026.646.646 0 00.026-.894l-2.366-2.586h.949c1.159 0 2.135-.82 2.41-1.928h1.024c.34 0 .614-.283.614-.633a.624.624 0 00-.614-.632z"
          fill="#F68E00"
        />
        <Path
          d="M27.996 31.369H26.97a2.59 2.59 0 00-.266-.663h1.29c.34 0 .615-.283.615-.632a.624.624 0 00-.614-.633h-5.807a.624.624 0 00-.614.633c0 .349.275.632.614.632h2.372c.47 0 .881.268 1.097.663h-3.469a.624.624 0 00-.614.633c0 .349.275.632.614.632h3.469a1.254 1.254 0 01-1.097.663H22.19a.614.614 0 00-.564.381.647.647 0 00.117.685l3.342 3.653a.603.603 0 00.87.026.646.646 0 00.025-.894l-2.366-2.586h.948c1.16 0 2.136-.82 2.41-1.928h1.025c.339 0 .614-.283.614-.633a.624.624 0 00-.614-.632z"
          fill="#FFEA94"
        />
        <Path
          d="M35.365 14.275c-3.322-.621-6.57.624-8.677 2.997-1.108-2.972-3.688-5.306-7.01-5.927-2.89-.54-5.685 1.39-6.229 4.304-.544 2.912 1.366 5.721 4.257 6.26l6.522 1.219 2.642.493 6.523 1.218c2.89.54 5.685-1.39 6.23-4.303.543-2.913-1.366-5.722-4.257-6.261h-.001zm-17.14 4.856c-1.435-.267-2.381-1.66-2.112-3.105.27-1.445 1.657-2.402 3.09-2.134 3.144.586 5.355 3.33 5.409 6.433l-6.388-1.194zm15.685 2.93l-6.387-1.193c1.17-2.872 4.222-4.634 7.365-4.047 1.434.267 2.381 1.66 2.111 3.106a2.659 2.659 0 01-3.09 2.134h.001z"
          fill="url(#paint0_radial_103_2627)"
        />
        <Path
          d="M43.813 23.474l-35.19-6.62c-.375-.07-.749.256-.837.729l-.86 4.637c-.087.473.145.913.519.983l35.19 6.619c.375.07.749-.256.836-.728l.86-4.637c.088-.473-.144-.913-.518-.983z"
          fill="url(#paint1_radial_103_2627)"
        />
        <Path
          d="M8.71 35.374h31.887V49.77c0 1.303-1.027 2.361-2.293 2.361h-27.3c-1.266 0-2.294-1.057-2.294-2.361V35.374z"
          fill="url(#paint2_radial_103_2627)"
        />
        <Path
          d="M32.493 21.318L20.97 19.15l-1.18 6.362 11.524 2.167 1.18-6.361z"
          fill="url(#paint3_radial_103_2627)"
        />
        <Path
          d="M30.857 35.374H19.13V52.13h11.727V35.374z"
          fill="url(#paint4_radial_103_2627)"
        />
        <Path
          d="M12.5 30.5c-.11-3.21-1.757-5.193-5.5-5.5 3.964.243 5.84-1.525 5.5-5.5.024 3.718 2.098 5.302 5.5 5.5-3.25.483-5.134 2.266-5.5 5.5zM34.5 39.5c-.07-2.044-1.118-3.305-3.5-3.5 2.523.155 3.718-.97 3.5-3.5.015 2.367 1.335 3.374 3.5 3.5-2.068.308-3.268 1.443-3.5 3.5z"
          fill="#FFB21C"
        />
      </G>
      <Defs>
        <RadialGradient
          id="paint0_radial_103_2627"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(-23.61388 7.71684 -5.53465 -16.9363 38.362 14.447)"
        >
          <Stop stopColor="#9DC2FF" />
          <Stop offset={1} stopColor="#3D7FEB" />
        </RadialGradient>
        <RadialGradient
          id="paint1_radial_103_2627"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(-179.902 20.827 11.728) scale(31.9248 10.6968)"
        >
          <Stop stopColor="#9DC2FF" />
          <Stop offset={1} stopColor="#3D7FEB" />
        </RadialGradient>
        <RadialGradient
          id="paint2_radial_103_2627"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(150.593 14.301 23.24) scale(30.9072 24.5883)"
        >
          <Stop stopColor="#9DC2FF" />
          <Stop offset={1} stopColor="#3D7FEB" />
        </RadialGradient>
        <RadialGradient
          id="paint3_radial_103_2627"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(-11.23764 4.05688 -3.10366 -8.59719 30.6 21.354)"
        >
          <Stop stopColor="#FFE0B9" />
          <Stop offset={1} stopColor="#DCAD70" />
        </RadialGradient>
        <RadialGradient
          id="paint4_radial_103_2627"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(-10.30956 15.70495 -12.58486 -8.26137 29.002 36.373)"
        >
          <Stop stopColor="#FFE0B9" />
          <Stop offset={1} stopColor="#DCAD70" />
        </RadialGradient>
        <ClipPath id="clip0_103_2627">
          <Rect x={0.333252} width={48} height={48} rx={8} fill="#fff" />
        </ClipPath>
      </Defs>
    </Svg>
  )
}

export default ReferAndEarnSVG
